import { Injectable ,Inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Router, ActivatedRoute } from '@angular/router';
import { environment } from '../../../../environments/environment';
import { LoginModel } from '../models/login.model';
import { JwtHelperService } from '@auth0/angular-jwt';
import { HttpHelperService } from '../../../shared/services/http-helper.service';
import { UserProfileModel } from '../models/user-profile.model';
import { ContactInfo } from '../models/contact-infoModel';
import { ChangePassword } from '../models/change-password';
import { DeliveryInformation } from '../../cart/models/delivery-information';
import { EventEmitter } from '@angular/core';
import { SecurityObject } from '../models/security-object.model';
import { SalesSttings } from '../models/sales-settings';
import { CashWay } from '../models/cash-way';

@Injectable({ providedIn: 'root' })
export class AuthService {
  public token:string ;
  controllerName: string = 'ApiECommerceAccount';
  controllerName2: string = 'ApiECommerceSalesOrder';
  controllerName4: string = 'ApiECommerceInventory';
  zommController: string = 'ApiZoomMeeting';
  urlGetList = "GenerateTranslationFiles";
  urlGetAll = "getallcategories";
  urlLogOut = "Logout";
  controllerName3 = "ApiTranslatorGenerator";
  public header ;
  public lang ;
  public isDeliveryInfoChanged: EventEmitter<boolean> = new EventEmitter<boolean>();
  constructor(private jwtHelper: JwtHelperService, private httpHelperService: HttpHelperService) {
      if(localStorage.getItem("jwt")){
        this.token = localStorage.getItem("jwt");
      }else{
        this.token = "9iZ8s/Z/3YEZONQl8t4qqYBfj7qLyg+MV5OLfNsG+YGYN722JHDavnFFkgJxyy11y0ErdwY5Upy8BHdUhmrm1WKccGrcok5uZcNk7dgxwpY1JeDNAKnIITzOG5fEBjUihnqFY/2IzC7kPF2sN0hryLU2nqX0hCpcRP54oOHazwhAtoAkuhWJ+uBJjUjmfFPyksRbdRVsRILnU18B7A0/6dN89VnAAXYAGMHoByvZ1JHU2zNKYp4XrYhshvMyGMAaX4BJ2BVUl8BPL2gBfLdxBVOYNtnQIvoSg3lLFHG4VxU5pL1jv7NAHd1Pz3l/IpsFOaS9Y7+zQB2xq1gM3RoZcC3jDHxg8tQpF5/5sHu3T0/Hekb6orO1YqkcstkCZFrZNz+RMOjFhXvRlc2r6VxnlqausGtF3rEG0ZXNq+lcZ5bCb2bAEzZp/dGVzavpXGeW0v7jjnqaTZbRlc2r6VxnlnlpHwLls0WTyRxFoJvR/8K5PtXZt2V6d/F6SVi8tZ42p3pHMsL8+3uIbIbzMhjAGhzcWOjZ+wTd23zxvWzYXRU76riB85AJi4czk0aVEL4fedvRIKSUtEJo55tHRNumRiXfotwsLiE5XEoAkB4S9cfqEEQCXAThf8tDAU8myx30t8Hqab01tl+bQH/e4KnAa2XBoDlrlEVkp8TRDmZLC9IUW53qM6ELE5ay+0U6z2dm1cffGJz/tQw4hUJNhXiLsTzzc/SYWmnLrGEz1zG7IjLqmNsRnOmviy3/G5BoV7W19QJow52/cHl0bzlbxIPFVaofgc2P8GRn6osV4JKRuHCWGIMNo9O46FSuQOPV+qedccD/0wAZByJ5uRShJdV/K3U3m4JInQ87UE0Fy6s7JJqcWebWSI6fPSCIkhBq3gbzZnTaZCb9EUEl3WUMKUm4OI5WSaLeOiDG3Ldc2CC0n1I=";
      }
       this.header = new HttpHeaders().set(
        "access-token",
          this.token
      );
      var currentLang = localStorage.getItem("lang");
      if(currentLang !=null){
        if(currentLang == "Arabic"){
          currentLang = "1";
        }else{
          currentLang = "2";
        }
      }
      this.lang = new HttpHeaders().set(
        "language-id",
          currentLang
      ); 
  }
/////////////////////////////////////////////////////////////////
  isUserAuthenticated() {
    let token: string = localStorage.getItem("jwt");
    if (token && !this.jwtHelper.isTokenExpired(token)) {
      return true;
    }
    else {
      return false;
    }
  }
/////////////////////////////////////////////////////////////////
 
/////////////////////////////////////////////////////////////////
login(model: LoginModel): any {
  return this.httpHelperService._http.post(`${this.httpHelperService.baseUrl}api/${this.controllerName}/LoginReturnToken`, model);
}
/////////////////////////////////////////////////////////////////
saveToken(fcmToken:string): any {
  return this.httpHelperService._http.get(`${this.httpHelperService.baseUrl}api/${this.controllerName}/UpdateFcmTokenToCurrentLogedUser?fcmToken=${fcmToken}`);
}
/////////////////////////////////////////////////////////////////
loginByProfileId(profileId:number): any {
  return this.httpHelperService._http.get(`${this.httpHelperService.baseUrl}api/${this.controllerName}/LoginTableName?profileId=${profileId}`);
}
/////////////////////////////////////////////////////////////////
downloadImage(referenceId,referenceTypeId): any {
    return this.httpHelperService._http.get(`${this.httpHelperService.imageUrl}?referenceId=${referenceId}&referenceTypeId=${referenceTypeId}`, {headers:this.header});
  }
/////////////////////////////////////////////////////////////////
  getUserById(userId: number): any {
    return this.httpHelperService._http.get(`${this.httpHelperService.baseUrl}api/${this.controllerName}/GetUserProfileByUserId?id=${userId}`);
  }
/////////////////////////////////////////////////////////////////
  register(model: UserProfileModel) {
    return this.httpHelperService._http.post(`${this.httpHelperService.baseUrl}api/${this.controllerName}/Registration`, model);
  }
/////////////////////////////////////////////////////////////////
  changePasswordApi(model:ChangePassword){
    return this.httpHelperService._http.post(`${this.httpHelperService.baseUrl}api/${this.controllerName}/ChangePassword`, model);
  }
/////////////////////////////////////////////////////////////////
  getRegistrationLookUp(): any {
    return this.httpHelperService._http.get(`${this.httpHelperService.baseUrl}api/${this.controllerName}/GetRegistrationLookUp`);
  }
/////////////////////////////////////////////////////////////////
  updateAccountInfo(model: UserProfileModel): any {
    return this.httpHelperService._http.post(`${this.httpHelperService.baseUrl}api/${this.controllerName}/UpdateContactInfo`,model);
  }
/////////////////////////////////////////////////////////////////
  addDeliveryInformation(model: ContactInfo): any {
    return this.httpHelperService._http.post(`${this.httpHelperService.baseUrl}api/${this.controllerName}/AddDeliveryInformation`,model);
  }
/////////////////////////////////////////////////////////////////
  updateDefaultDeliveryInformation(model: ContactInfo): any {
    return this.httpHelperService._http.post(`${this.httpHelperService.baseUrl}api/${this.controllerName}/UpdateDefaultDeliveryInformation`,model);
  }
/////////////////////////////////////////////////////////////////   
  deleteDeliveryInformation(deliveryInfoId: number): any {
    return this.httpHelperService._http.delete(`${this.httpHelperService.baseUrl}api/${this.controllerName}/DeleteDeliveryInformation?deliveryInfoId=${deliveryInfoId}`,{headers:this.header});
  }
/////////////////////////////////////////////////////////////////
  getDelievryInformationByProfileId(profileId: number): any {
    return this.httpHelperService._http.get(`${this.httpHelperService.baseUrl}api/${this.controllerName}/GetDelievryInformatioByProfileId?profileId=${profileId}`,{headers:this.header});
  }
/////////////////////////////////////////////////////////////////
  getSalesSttings(): any {
   // return this.httpHelperService._http.get(`${this.httpHelperService.baseUrl}api/${this.controllerName2}/GetTaxAndDiscount`,{headers:this.header});
  }
/////////////////////////////////////////////////////////////////
  getCashWay(): any {
    return this.httpHelperService._http.get(`${this.httpHelperService.baseUrl}api/${this.controllerName2}/GetAvailablePaymentMethod`,{headers:this.header});
  }
/////////////////////////////////////////////////////////////////
  clearLocalStorage() {
    localStorage.clear();
  }
/////////////////////////////////////////////////////////////////
  setUserProfileInLocalStorage(userProfileModel: UserProfileModel) {
    localStorage.setItem('userProfile', JSON.stringify(userProfileModel));
  }
/////////////////////////////////////////////////////////////////
  setUserSecurityObjectInLocalStorage(securityObject: SecurityObject) {
    localStorage.setItem('securityObject', JSON.stringify(securityObject));
  }
/////////////////////////////////////////////////////////////////
  getSelectedLang():string {
    return localStorage.getItem('lang');
  }
/////////////////////////////////////////////////////////////////
  getUserSecurityObjectFRomLocalStorage(): SecurityObject {
    return JSON.parse(localStorage.getItem('securityObject'));
  }
/////////////////////////////////////////////////////////////////
  setSalesSttingsInLocalStorage(salesSttings: SalesSttings) {
    localStorage.setItem('salesSttings', JSON.stringify(salesSttings));
  }
/////////////////////////////////////////////////////////////////
  getSalesSttingsFRomLocalStorage(): SalesSttings {
    return JSON.parse(localStorage.getItem('salesSttings'));
  }
/////////////////////////////////////////////////////////////////
  setCashWayInLocalStorage(cashWay: CashWay) {
    localStorage.setItem('cashWay', JSON.stringify(cashWay));
  }
/////////////////////////////////////////////////////////////////
  getCashWayFRomLocalStorage(): CashWay {
    return JSON.parse(localStorage.getItem('cashWay'));
  }
/////////////////////////////////////////////////////////////////
  setUserDefaultDeliveryInfoInLocalStorage(deliveryInfoModel: DeliveryInformation) {
    localStorage.setItem('DeliveryInformation', JSON.stringify(deliveryInfoModel));
  }
/////////////////////////////////////////////////////////////////
  public removeUserDefaultDeliveryInfoFromLocalStorage(): any {
    localStorage.removeItem('DeliveryInformation');
  }
/////////////////////////////////////////////////////////////////
  getUserDefaultDeliveryInfoFromLocalStorage(): DeliveryInformation {
    return JSON.parse(localStorage.getItem('DeliveryInformation'));
  }
/////////////////////////////////////////////////////////////////
  updateUserDefaultDeliveryInfoInLocalStorage(deliveryInfoModel: DeliveryInformation) {
    this.removeUserDefaultDeliveryInfoFromLocalStorage();
    this.setUserDefaultDeliveryInfoInLocalStorage(deliveryInfoModel);
    this.isDeliveryInfoChanged.emit(true);
  }
/////////////////////////////////////////////////////////////////
  getUserProfileFromLocalStorage(): UserProfileModel {
    return JSON.parse(localStorage.getItem('userProfile'));
  }
/////////////////////////////////////////////////////////////////  
zommMetting(sessionId:number): any {
  return this.httpHelperService._http.get(`${this.httpHelperService.baseUrl}api/${this.zommController}/GetViewModel?SessionId=${sessionId}`,{headers:this.header});
}
/////////////////////////////////////////////////////////////////
getHomeContent(): any {
  return this.httpHelperService._http.get(`${this.httpHelperService.baseUrl}api/ApiEcommerceCms/GetHomePageContent?Start=-1&End=0&searchValue=&orderby=&dir=`,{headers:this.header});
}
/////////////////////////////////////////////////////////////////
getSpecificSection(templateId,contentTypeId,contentId): any {
  return this.httpHelperService._http.get(`${this.httpHelperService.baseUrl}/home/MainSections?templateId=${templateId}&ContentTypeId=${contentTypeId}&contentId=${contentId}`,{headers:this.lang,responseType: 'text' });
}
/////////////////////////////////////////////////////////////////
generateTranslation(): any { 
  return this.httpHelperService._http.get(`${this.httpHelperService.baseUrl}api/${this.controllerName3}/${this.urlGetList}`,{headers:this.header});
}
////////////////////////////////////////////////////////////////
getAllCategories(): any{
  return this.httpHelperService._http.get(this.httpHelperService.baseUrl + 'api/' + this.controllerName4 + '/' + this.urlGetAll + '?Start=0&End=32&orderby=&dir=',{headers:this.header});
}
////////////////////////////////////////////////////////////////
logout(): any{
  return this.httpHelperService._http.get(this.httpHelperService.baseUrl + 'api/' + this.controllerName + '/' + this.urlLogOut);
}
}